import { formati } from "../formati.ts";

const f = formati("it");

/** Parole che tornano in più schermate. */
export const comune = {
  "comune.salva": "Salva",
  "comune.salvato": "Salvato.",
  "comune.annulla": "Annulla",
  "comune.elimina": "Elimina",
  "comune.chiudi": "Chiudi",
  "comune.copia": "Copia",
  "comune.copiato": "Copiato",
  "comune.mostra": "mostra",
  "comune.nascondi": "nascondi",
  "comune.lingua": "Lingua",
  "errori.rete": "Impossibile raggiungere il server Portman. Verifica che sia in esecuzione.",
  "errori.http": (p: { status: number }) => `La richiesta è fallita (codice ${p.status}).`,
  "comune.elementi": (p: { n: number }) =>
    `${f.numero(p.n)} ${f.plurale(p.n, { one: "elemento", other: "elementi" })}`,
};
